/**
 * Mon compte v2 (SPEC § 4.4, § 4.5, § 4.9, EN3). Route : account/*.
 * = App.tsx AccountRoutes() : mêmes sous-routes publiques (liens des e-mails, des menus des thèmes,
 * retours Alma), celles du membre seulement une fois connecté :
 * - index : Mon compte (connecté) ou carte de connexion / inscription (déconnecté) ;
 * - reset-password : mot de passe oublié ;
 * - edit, visits, services : informations, « Voir tous mes cours », « Voir tous mes crédits ».
 * Habillage : account.css (règles sous #mindbody-app[data-ux='v2'].mmv2).
 */
import { useUserContext } from 'providers/useUserContext';
import { useMemo } from 'react';
import { Navigate, RouteObject, useLocation, useRoutes } from 'react-router';
import { AccountHome } from './AccountHome';
import { AccountSignedOut } from './AccountSignedOut';
import { MyClasses } from './MyClasses';
import { MyCredits } from './MyCredits';
import { ProfileEdit } from './ProfileEdit';
import { ResetPassword } from './ResetPassword';
import { injectV2Css } from '../../styles/inject';
import accountCss from './account.css?inline';

injectV2Css('screens/Account/account.css', accountCss);

/** Page de Mon compte réservée aux membres, visiteur déconnecté : carte de connexion, avec la page demandée. */
function ToSignIn() {
  const { pathname } = useLocation();
  return <Navigate to="/account" replace state={{ signInFrom: pathname }} />;
}

function AccountIndex() {
  const { isLoggedIn } = useUserContext();
  return isLoggedIn ? <AccountHome /> : <AccountSignedOut />;
}

export function AccountRoutesV2() {
  const { isLoggedIn } = useUserContext();

  const routes = useMemo(() => {
    const list: RouteObject[] = [
      { index: true, Component: AccountIndex },
      { path: 'reset-password', Component: ResetPassword },
      { path: '*', Component: ToSignIn },
    ];

    if (isLoggedIn) {
      list.push(
        { path: 'edit', Component: ProfileEdit },
        { path: 'visits', Component: MyClasses },
        { path: 'services', Component: MyCredits },
      );
    }

    return list;
  }, [isLoggedIn]);

  return useRoutes(routes);
}
